module.exports = __webpack_public_path__ + "static/media/10_r_lampa2_80.94_0.366fc552.png";